<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <h4>Mağaza Ekle</h4>
      <v-row style="margin-top: 100px;">
        <v-col cols="12" md="4">
          <h4>Mağaza Adı</h4>
          <v-text-field
            v-model="venue.venueName"
            maxlength="255"
            counter="255"
            :rules="venueNameRules"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <h4>Firma</h4>
          <v-select
            v-model="venue.companyId"
            :items="allCompanyList"
            item-text="companyName"
            item-value="id"
            label="Seçiniz"
            data-vv-name="select"
            required
            @change="onCompanyChange"
          ></v-select>
        </v-col>
        <v-col cols="12" md="8"></v-col>
        <template v-if="showVenueStoreType">
          <v-col cols="12" md="4">
            <h4>Mağaza Tipi</h4>
            <v-select
              v-model="chooseVenueStore"
              :items="venueStoreType"
              item-text="name"
              item-value="type"
              label="Seçiniz"
              data-vv-name="select"
              required
            ></v-select>
          </v-col>
        </template>
        <v-col cols="12" md="8"></v-col>

        <!-- <v-col cols="12" md="4">
          <h4>Mağaza Resimleri <span style="color:red;">(375 x 285)</span>
          </h4>
          <div v-for="(item,index) in venueImages" :key="'venueImage'+index">
            <v-row>
              <v-col cols="12" md="11">
                <v-img
                    style="cursor:pointer;"
                    v-if="venueImages[index].imgUrl!='' && venueImages[index].imgUrl!=undefined"
                    :src="venueImages[index].imgUrl"
                    aspect-ratio="1.7"
                ></v-img>
                <v-file-input
                    show-size
                    accept="image/*"
                    v-model="venueImages[index].file"
                    @change="previewFiles(index)"
                    :rules="fileRules"
                    label="Resim yükle"
                    required
                ></v-file-input>
              </v-col>
              <v-col cols="12" md="1" style="margin-top:12px;">
                <v-btn color="error" @click="removeVenueImage(index)">Çıkar</v-btn>
              </v-col>
            </v-row>
          </div>
          <v-btn color="#4d48f9" style="margin-top:10px;color:white;" @click="addVenueImage()">Ekle</v-btn>
        </v-col> -->

        <v-col cols="12" md="8"></v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <v-btn
            color="#4d48f9"
            style="margin-top: 10px; color: white;"
            @click="addExecutive()"
          >
            YETKİLİ EKLE
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        v-for="(executive, index) in venue.venueExecutiveList"
        :key="index"
      >
        <v-col cols="12" md="2">
          <h4>Yetkili Ad & Soyad</h4>
          <v-text-field
            v-model="executive.fullName"
            maxlength="255"
            minlength="2"
            counter="255"
            required
            :rules="executiveFullNameRules"
          ></v-text-field>
        </v-col>
        <!-- <v-col cols="12" md="2">
          <h4>Yetkili Soyad</h4>
          <v-text-field
              v-model="executive.surName"
              maxlength="255"
              counter="255"
              minlength="2"
              required
              :rules="executiveSurNameRules"

          ></v-text-field>
        </v-col> -->
        <v-col cols="12" md="3">
          <h4>Yetkili Ünvan</h4>
          <v-text-field
            v-model="executive.title"
            maxlength="255"
            counter="255"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2">
          <h4>Yetkili Telefon</h4>
          <v-text-field
            v-model="executive.phoneNumber"
            maxlength="15"
            counter="15"
            required
            v-mask="'(###) ### ## ##'"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <h4>&nbsp;</h4>
          <v-btn
            style="margin-top: 10px; color: red;"
            @click="deleteExecutive(index)"
          >
            YETKİLİ SİL
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <h4>Çalışma Saatleri</h4>
        </v-col>
      </v-row>
      <div v-for="(item, i) in venue.workingHourList" :key="i + 'a'">
        <v-row>
          <v-col
            cols="12"
            md="3"
            style="align-self: center; margin-top: -3px; text-align: center;"
          >
            <h5>{{ item.name }}</h5>
          </v-col>
          <v-col cols="12" md="3">
            <div class="input-container">
              <i class="material-icons hour-icon">access_time</i>
              <div class="container" style="padding-top: 0;">
                <label :for="'openHour-' + i" class="label">Açılış</label>
                <div>
                  <vue-timepicker
                    manual-input
                    hide-dropdown
                    v-model="venue.workingHourList[i].openHour"
                    :disabled="venue.workingHourList[i].close"
                    @change="
                      syncWorkingHoursForOpen(
                        venue.workingHourList[i].openHour,
                        i,
                      )
                    "
                    @focus="focusState = 'focused'"
                    @blur="focusState = 'blurred'"
                    @open="dropdownState = 'opened'"
                    @close="dropdownState = 'closed'"
                  ></vue-timepicker>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="input-container">
              <i class="material-icons hour-icon">access_time</i>
              <div class="container" style="padding-top: 0;">
                <label :for="'closeHour-' + i" class="label">Kapanış</label>
                <div>
                  <vue-timepicker
                    manual-input
                    hide-dropdown
                    v-model="venue.workingHourList[i].closeHour"
                    :disabled="venue.workingHourList[i].close"
                    @change="
                      syncWorkingHoursForClose(
                        venue.workingHourList[i].closeHour,
                        i,
                      )
                    "
                    @focus="focusState = 'focused'"
                    @blur="focusState = 'blurred'"
                    @open="dropdownState = 'opened'"
                    @close="dropdownState = 'closed'"
                  ></vue-timepicker>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <v-checkbox
              v-model="venue.workingHourList[i].close"
              label="Kapalı"
            ></v-checkbox>
          </v-col>
        </v-row>
      </div>
      <v-row>
        <v-col cols="12" md="12">
          <h4>Mağaza Özellikleri</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          sm="3"
          md="3"
          v-for="(item, index) in allResources"
          :id="'resources' + index"
          :key="item.id + 'resources'"
        >
          <v-checkbox
            :label="item.resource"
            color="#4d48f9"
            style="padding-top: 0px;"
            @change="resourceStatusChange(item, $event)"
            hide-details
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <h4>Anlaşma Tipi</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="3" md="3" v-for="item in planTypes" :key="item">
          <v-radio-group v-model="selectedPlanType">
            <v-radio
              :label="item"
              :value="item"
              color="#4d48f9"
              hide-details
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <h4>Bardak Boyu Seçenekleri</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-show="coffeeOptionForPlanTypes(coffeeOption)"
          cols="12"
          sm="12"
          md="12"
          v-for="(coffeeOption, index) in allCoffeeOptions"
          :id="coffeeOption.id + '_coffeeOptions_' + index"
          :key="coffeeOption.id + '_coffeeOptions_' + index"
        >
          <v-checkbox
            v-if="coffeeOptionForPlanTypes(coffeeOption)"
            :label="coffeeOption.title"
            v-model="coffeeOption.checked"
            color="#4d48f9"
            style="padding-top: 4px;"
            @change="coffeeOptionStatusChange(coffeeOption, $event)"
            hide-details
          ></v-checkbox>
          <v-row v-show="coffeeOption.checked">
            <v-col
              cols="12"
              sm="3"
              md="3"
              v-for="(item, index) in allCoffeeSize.filter(
                (x) => x.coffeeOptionId == coffeeOption.id,
              )"
              :id="
                'coffeeOption_' +
                coffeeOption.id +
                '_' +
                index +
                '_coffee_' +
                item.id
              "
              :key="
                'coffeeOption_' +
                coffeeOption.id +
                '_' +
                index +
                '_coffee_' +
                item.id
              "
            >
              <v-img
                :src="item.coffeeSizeImg"
                style="width: 50px; height: 80px;"
              ></v-img>
              <template v-if="coffeeExtras">
                <v-text-field
                  v-model="item.name"
                  label="Kahve hacmi"
                  @input="coffeeNameChange(item, $event)"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="item.milkyCode"
                  label="Sütlü Kod"
                  @input="coffeeMilkyChange(item, $event)"
                ></v-text-field>
                <v-text-field
                  v-model="item.withoutMilkyCode"
                  label="Sütsüz Kod"
                  @input="coffeeWithoutMilkyChange(item, $event)"
                ></v-text-field>
              </template>
              <v-checkbox
                :label="item.coffeeSize"
                v-model="item.checked"
                color="#4d48f9"
                style="padding-top: 0px;"
                @change="coffeeStatusChange(item, $event)"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <h4>Süt Seçimleri</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          sm="3"
          md="3"
          v-for="item in allMilkTypes"
          :key="item.id + 'milk'"
        >
          <v-checkbox
            :label="item.milkType"
            color="#4d48f9"
            @change="milkTypeStatusChange(item, $event)"
            hide-details
          ></v-checkbox>
          <v-text-field
            v-if="coffeeExtras"
            v-model="item.milkTypeCode"
            @input="milkTypeCodeChange(item, $event)"
            :readonly="true"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <h4>Adres</h4>
          <v-textarea
            v-model="venue.address"
            maxlength="255"
            counter="255"
            rows="1"
            auto-grow
            :rules="addressRules"
            required
          ></v-textarea>
        </v-col>
        <v-col cols="6" md="6">
          <h4>Şehir</h4>
          <v-select
            v-model="venue.cityId"
            :items="allCities"
            item-text="name"
            item-value="id"
            :rules="cityRule"
            label="Seçiniz"
            data-vv-name="select"
            required
            @change="cityChange(item, $event)"
          ></v-select>
        </v-col>
        <v-col cols="6" md="6">
          <h4>İlçe</h4>
          <v-select
            v-model="venue.districtId"
            :items="districtList"
            item-text="name"
            item-value="id"
            :rules="districtRule"
            label="Seçiniz"
            data-vv-name="select"
            required
            @change="districtChange(item, $event)"
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <h4>Konum</h4>
          <h6>Enlem</h6>
          <v-text-field
            v-model="venue.latitude"
            min="0"
            type="number"
            :rules="locationXRules"
            required
          ></v-text-field>
          <h6>Boylam</h6>
          <v-text-field
            v-model="venue.longitude"
            min="0"
            type="number"
            :rules="locationYRules"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <h4>Aktif/Pasif</h4>
          <v-checkbox v-model="isOpen" color="#4d48f9"></v-checkbox>
        </v-col>
        <v-col cols="12" md="6" v-if="!isOpen">
          <h4>Yakında</h4>
          <v-checkbox
            v-model="isComingSoon"
            color="#4d48f9"
            :disabled="isOpen"
            :readonly="!isAdminOrVenueUser"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-col cols="12" md="7">
        <v-btn
          depressed
          color="#4d48f9"
          style="text-transform: none !important; float: right; color: white;"
          @click="venueAdd()"
        >
          EKLE
        </v-btn>
      </v-col>

      <v-dialog v-model="dialog" max-width="600">
        <v-card>
          <v-card-title class="headline">
            Lütfen alanları kontrol edin
          </v-card-title>

          <v-card-text>
            <ul>
              <li v-for="fruit in this.errorList" :key="fruit">{{ fruit }}</li>
            </ul>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- <v-row>
      </v-row>-->
    </v-container>
  </v-form>
</template>

<script>
const PlanTypes = {
  BasicPlan: 'Basic Paket Anlaşması',
  BasicPlusPlan: 'Basic + Plus Paket Anlaşması',
}
import { mapGetters, mapActions } from 'vuex'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import 'flatpickr/dist/flatpickr.css'
import company from '@/components/Dashboard/Company/Company.vue'

export default {
  components: {
    VueTimepicker,
  },
  name: 'Venue',

  data: () => ({
    isOpen: false,
    isComingSoon: false,
    chooseVenueStore: { type: 'AG', name: 'Al Götür Mağazası' },
    venueStoreType: [
      { type: 'AG', name: 'Al Götür Mağazası' },
      { type: 'TW', name: 'Bordo Mağaza' },
    ],
    selectedMilkTypes: [],
    venue: {
      venueName: '',
      venueImageList: [],
      selectVenueStore: 'AG',
      address: '',
      latitude: '',
      longitude: '',
      companyId: 0,
      districtId: 0,
      cityId: 0,
      resourceId: [],
      open: false,
      isComingSoon: false,
      coffeeSizeList: [],
      milkTypeId: [],
      workingHourList: [
        {
          openHour: null,
          closeHour: null,
          name: 'Pazartesi',
          workingDay: 'Monday',
          close: false,
        },
        {
          openHour: null,
          closeHour: null,
          name: 'Salı',
          workingDay: 'Tuesday',
          close: false,
        },
        {
          openHour: null,
          closeHour: null,
          name: 'Çarşamba',
          workingDay: 'Wednesday',
          close: false,
        },
        {
          openHour: null,
          closeHour: null,
          name: 'Perşembe',
          workingDay: 'Thursday',
          close: false,
        },
        {
          openHour: null,
          closeHour: null,
          name: 'Cuma',
          workingDay: 'Friday',
          close: false,
        },
        {
          openHour: null,
          closeHour: null,
          name: 'Cumartesi',
          workingDay: 'Saturday',
          close: false,
        },
        {
          openHour: null,
          closeHour: null,
          name: 'Pazar',
          workingDay: 'Sunday',
          close: false,
        },
      ],
      venueExecutiveList: [],
    },
    coffeeExtras: false,
    allCoffeeOptions: [],
    kahveDunyasiId: 0,
    showVenueStoreType: false,
    coffeeSizeList: [],
    venueMapImage: [],
    planTypes: PlanTypes,
    selectedPlanType: 'Basic Paket Anlaşması',
    coffeeOptionsForBasicPlan: ['FilterCoffee', 'ColdBrew'],
    executiveModel: {
      title: '',
      fullName: '',
      phoneNumber: '',
    },
    mapImageUrl: '',
    venueImages: [],
    valid: true,
    venueNameRules: [
      (v) => !!v || 'Mağaza/Tabela adı alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    ],
    executiveTitleRules: [
      (v) => !!v || 'Yetkili ünvanı adı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    ],
    executiveFullNameRules: [
      (v) => !!v || 'Yetkili adı&soyadı alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
      (v) => v.trim().length >= 2 || 'Minumum 2 karakter olmalıdır.',
    ],
    // executiveSurNameRules: [v => !!v || "Yetkili soyadı alanı zorunludur.",
    //   v => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    //   v => v.trim().length >=2 || 'Minumum 2 karakter olmalıdır.',
    // ],
    executivePhoneRules: [
      (v) => !!v || 'Yetkili telefon alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    ],
    addressRules: [
      (v) => !!v || 'Adres alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    ],
    coffeeNameRules: [(v) => !!v || 'Kahve hacmi alanı zorunludur.'],
    locationXRules: [
      (v) => !!v || 'Enlem alanı zorunludur.',
      (v) => parseFloat(v) > -1 || "Sıralama 0'dan küçük olmamalıdır.",
    ],
    locationYRules: [
      (v) => !!v || 'Boylam alanı zorunludur.',
      (v) => parseFloat(v) > -1 || "Sıralama 0'dan küçük olmamalıdır.",
    ],
    districtList: [],
    allCities: [],
    allCoffeeSize: [],
    codeRules: [(v) => !!v || 'Kod alanı zorunludur.'],
    // fileRules: [
    //   // value => value.size < 1000 || 'Avatar size should be less than 2 MB!',
    //   v => !!v || "Resim gereklidir.",
    //   v => (v && v.name != null) || "Resim gereklidir."
    // ],
    errorList: [],
    dialog: false,
    cityRule: [
      // value => value.size < 1000 || 'Avatar size should be less than 2 MB!',
      (v) => !!v || 'Şehir alanı zorunludur.',
    ],
    districtRule: [
      // value => value.size < 1000 || 'Avatar size should be less than 2 MB!',
      (v) => !!v || 'İlçe alanı zorunludur.',
    ],
    coffeeTypesObject: {
      Espresso: 'Espresso',
      Latte: 'Latte',
      IcedLatte: 'IcedLatte',
      Cappuccion: 'Cappuccino',
    },
    milkTypesObject: {
      WITH_MILK: 'Sütlü',
      WITHOUT_MILK: 'Sütsüz',
    },
    coffeeSizesObject: {
      SMALL: 'Small',
      MIDDLE: 'Middle',
      BIG: 'Big',
    },
  }),

  computed: mapGetters(['allCompanyList', 'allResources', 'allMilkTypes']),
  created() {
    const userRoles = JSON.parse(localStorage.getItem('userRoles'))

    if (
      userRoles.find((x) => x == 'PanelUser') != null &&
      userRoles.find((x) => x == 'PanelUser') != undefined
    ) {
      this.isAdmin = true
    }

    if (
      this.isAdmin ||
      (userRoles.find((x) => x == 'PanelVenueUser') != null &&
        userRoles.find((x) => x == 'PanelVenueUser') != undefined)
    ) {
      this.isAdminOrVenueUser = true
    }

    this.getCompanieList().then((companies) => {
      this.venue.companyId = companies[0].id
      if(companies[0].companyName == 'Kahve Dünyası'){
        this.showVenueStoreType = true;
      }
      const selectedCompany = this.allCompanyList.find(
        (company) => company.id === this.venue.companyId,
      )
      console.log(selectedCompany);
      this.coffeeExtras = selectedCompany.coffeeExtras == 'True'
      companies.filter((company) => {
        if (company.companyName == 'Kahve Dünyası')
          this.kahveDunyasiId = company.id
        if (this.targetCompanies.includes(company.companyName)) {
          this.targetCompaniesId.push(company.id)
        }
      })
    })
    this.getCoffeeOptionList().then((coffeeOptionList) => {
      this.allCoffeeOptions = coffeeOptionList
      this.getCoffeeSizeList().then((coffeeSizeList) => {
        coffeeSizeList.forEach((item) => {
          this.allCoffeeOptions.forEach((coffeeOption, y) => {
            if (
              (coffeeOption.coffeeType === this.coffeeTypesObject.Espresso &&
                item.coffeeSizeType !== this.coffeeSizesObject.BIG &&
                item.coffeeSizeType !== this.coffeeSizesObject.MIDDLE) ||
              coffeeOption.coffeeType !== this.coffeeTypesObject.Espresso
            ) {
              this.coffeeSizeList.push({
                checked: false,
                name: '',
                milkyCode: '',
                withoutMilkyCode: '',
                coffeeOptionId: coffeeOption.id,
                coffeeSize: item.coffeeSize,
                coffeeSizeImg: item.image,
                coffeeSizeType: item.coffeeSizeType,
                id: item.id,
              })
            }
          })
        })
        this.allCoffeeSize = this.coffeeSizeList
      })
    })

    this.getResourceList()
    this.getMilkTypeList()
    this.getCityList().then((cityList) => {
      this.allCities = cityList
    })
    if (this.venue.cityId) {
      this.getDistrictList(this.venueData.cityId).then((districtList) => {
        if (!this.venue.cityId) return

        this.districtList = districtList
        this.venue.districtId = null
      })
    }
  },
  watch: {
    chooseVenueStore: function (val) {
      // if(val=="Al Götür Mağazası")
      this.venue.selectVenueStore = val
      // else
      //   this.venue.selectVenueStore="TW";
    },
    isOpen(newValue) {
      if (newValue) {
        //isOpen true olduğunda isComingSoon değerlerini boşalt
        this.isComingSoon = false
      }
    },
  },
  methods: {
    ...mapActions([
      'getCompanieList',
      'getCoffeeOptionList',
      'getCoffeeSizeList',
      'getResourceList',
      'getMilkTypeList',
      'addVenue',
      'getCityList',
      'getDistrictList',
    ]),
    routeVenues() {
      this.$router.push('/dashboard/venues')
    },
    coffeeOptionStatusChange(item, newValue) {
      if (this.allCoffeeSize.length === 0)
        this.getCoffeeSizeList().then((coffeeSizeList) => {
          coffeeSizeList.forEach((item) => {
            this.allCoffeeOptions.forEach((coffeeOption, y) => {
              this.coffeeSizeList.push({
                checked: false,
                name: '',
                milkyCode: '',
                withoutMilkyCode: '',
                coffeeOptionId: coffeeOption.id,
                coffeeSize: item.coffeeSize,
                coffeeSizeImg: item.image,
                coffeeSizeType: item.coffeeSizeType,
                id: item.id,
              })
            })
          })
          this.allCoffeeSize = this.coffeeSizeList
        })
    },
    venueMilkControl() {
      if (this.selectedMilkTypes.length === 0) return false

      let flag = false
      this.selectedMilkTypes.forEach((milk) => {
        if (milk.milkType === 'Sütsüz') flag = true
      })

      return !(flag === true && this.selectedMilkTypes.length <= 1)
    },
    venueAdd() {
      const coffeeOptionIds = this.allCoffeeOptions
        .filter((x) => x.checked)
        .map((x) => x.id)
      this.venue.hasPlusPackage = this.selectedPlanType !== PlanTypes.BasicPlan
      this.venue.isComingSoon = this.isComingSoon
      this.venue.isOpen = this.isOpen

      let addedCoffeeSizeList = []
      this.coffeeSizeList
        .filter((x) => coffeeOptionIds.includes(x.coffeeOptionId) && x.checked)
        .forEach((x) =>
          addedCoffeeSizeList.push({
            id: x.id,
            milkyCode: x.milkyCode,
            name: x.name,
            withoutMilkyCode: x.withoutMilkyCode,
            coffeeOptionId: x.coffeeOptionId,
          }),
        )

      if (this.$refs.form.validate()) {
        this.snackbar = true
        for (let i = 0; i < this.venueImages.length; i++) {
          this.getBase64(this.venueImages[i].file).then((data) => {
            this.venue.venueImageList.push(data)
          })
        }
        for (let i = 0; i < this.venue.workingHourList.length; i++) {
          if (!this.venue.workingHourList[i].close) {
            if (typeof this.venue.workingHourList[i].openHour !== 'object') {
              this.venue.workingHourList[i].openHour = {
                HH: this.venue.workingHourList[i].openHour.split(':')[0],
                mm: this.venue.workingHourList[i].openHour.split(':')[1],
              }
            }
            if (typeof this.venue.workingHourList[i].closeHour !== 'object') {
              this.venue.workingHourList[i].closeHour = {
                HH: this.venue.workingHourList[i].closeHour.split(':')[0],
                mm: this.venue.workingHourList[i].closeHour.split(':')[1],
              }
            }
            const workingHourListControl = this.workingHourControl(
              this.venue.workingHourList[i].openHour,
              this.venue.workingHourList[i].closeHour,
            )
            if (workingHourListControl === true) {
              return
            }
            const openHour =
              this.venue.workingHourList[i].openHour.HH +
              ':' +
              this.venue.workingHourList[i].openHour.mm
            const closeHour =
              this.venue.workingHourList[i].closeHour.HH +
              ':' +
              this.venue.workingHourList[i].closeHour.mm
            this.venue.workingHourList[i].openHour = openHour
            this.venue.workingHourList[i].closeHour = closeHour
          } else {
            this.venue.workingHourList[i].openHour = '00:00'
            this.venue.workingHourList[i].closeHour = '00:00'
          }
        }
        this.venue.longitude = parseFloat(this.venue.longitude)
        this.venue.latitude = parseFloat(this.venue.latitude)
        this.venue.coffeeSizeList = addedCoffeeSizeList
        let milkControl = this.venueMilkControl()
        if (!milkControl) {
          this.errorList = []
          this.errorList.push('Lütfen en az 1 tane süt tercihi yapınız')
          this.dialog = true
          return
        }
        this.addVenue(this.venue)
          .then((response) => {
            if (response.processStatus == 'Success') {
              this.$router.push('/dashboard/venues')
            } else {
              this.errorList = []
              this.errorList.push(response.friendlyMessage.message)
              this.dialog = true
            }
          })
          .catch((err) => {
            const res = err.response.data

            if(res.friendlyMessage && res.friendlyMessage.message) {
              if(res.friendlyMessage.message == 'venue_already_exist'){
                alert('Aynı isimde başka bir mağaza bulunmaktadır. Mağaza adını güncelleyiniz.')
              }
            }
            else {
            this.errorList = []
            this.errorList = Object.values(res.errors).flat()
            this.dialog = true
            }
          })
      } else {
        var errors = []
        var x = document.getElementsByClassName('v-messages__message')
        for (var i = 0; i < x.length; i++) errors.push(x[i].innerHTML)
        this.errorList = errors
        this.dialog = true
      }
    },
    previewFiles(index) {
      if (this.venueImages[index].file == undefined) {
        this.venueImages[index].imgUrl = ''
      } else {
        const file = this.venueImages[index].file
        this.venueImages[index].imgUrl = URL.createObjectURL(file)
      }
    },
    previewFilesWithMapImage() {
      if (this.venueMapImage == undefined) {
        this.mapImageUrl = ''
      } else {
        const file = this.venueMapImage
        this.mapImageUrl = URL.createObjectURL(file)
      }
    },

    coffeeStatusChange(item, newValue) {
      let coffee = this.coffeeSizeList.find(
        (x) => x.id == item.id && x.coffeeOptionId == item.coffeeOptionId,
      )
      if (coffee != undefined) {
        this.coffeeSizeList.find(
          (x) => x.id == item.id && x.coffeeOptionId == item.coffeeOptionId,
        ).checked = newValue
      }
    },
    milkTypeCodeChange(item, newValue) {
      let milkType = (this.venue.milkTypeId.find(
        (x) => x.id == item.id,
      ).code = newValue)
    },
    cityChange(item, newValue) {
      this.getDistrictList(newValue).then((districtList) => {
        this.districtList = districtList
        this.venue.cityId = newValue
      })
    },
    districtChange(item, newValue) {
      this.districtId = newValue
    },

    coffeeNameChange(item, newValue) {
      let coffee = this.venue.coffeeSizeList.find(
        (x) => x.id == item.id && x.coffeeOptionId == item.coffeeOptionId,
      )
      if (coffee != undefined) {
        this.venue.coffeeSizeList.find(
          (x) => x.id == item.id && x.coffeeOptionId == item.coffeeOptionId,
        ).name = newValue
      }
    },
    coffeeMilkyChange(item, newValue) {
      let coffee = this.venue.coffeeSizeList.find(
        (x) => x.id == item.id && x.coffeeOptionId == item.coffeeOptionId,
      )
      if (coffee != undefined) {
        this.venue.coffeeSizeList.find(
          (x) => x.id == item.id && x.coffeeOptionId == item.coffeeOptionId,
        ).milkyCode = newValue
      }
    },
    coffeeWithoutMilkyChange(item, newValue) {
      let coffee = this.venue.coffeeSizeList.find(
        (x) => x.id == item.id && x.coffeeOptionId == item.coffeeOptionId,
      )
      if (coffee != undefined) {
        this.venue.coffeeSizeList.find(
          (x) => x.id == item.id && x.coffeeOptionId == item.coffeeOptionId,
        ).withoutMilkyCode = newValue
      }
    },
    resourceStatusChange(item, newValue) {
      if (newValue) {
        this.venue.resourceId.push(item.id)
      } else {
        this.venue.resourceId = this.venue.resourceId.filter(
          (x) => x != item.id,
        )
      }
    },
    milkTypeStatusChange(item, newValue) {
      if (newValue) {
        this.venue.milkTypeId.push({ id: item.id, code: item.milkTypeCode })
        this.selectedMilkTypes.push(item)
      } else {
        this.venue.milkTypeId = this.venue.milkTypeId.filter(
          (x) => x != item.id,
        )
        this.selectedMilkTypes = this.selectedMilkTypes.filter((x) => x != item)
      }
    },
    addVenueImage() {
      this.venueImages.push({
        file: null,
        imgUrl: '',
      })
    },
    addExecutive() {
      if (this.venue.venueExecutiveList.length < 2) {
        this.venue.venueExecutiveList.push(
          Object.assign({}, this.executiveModel),
        )
      } else {
        alert('Sadece 2 yetkili eklenebilir')
      }
    },
    deleteExecutive(index) {
      this.venue.venueExecutiveList.splice(index, 1)
    },
    removeVenueImage(index) {
      if (this.venueImages.length > 0) {
        this.venueImages.splice(index, 1)
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result.split(',')[1])
        reader.onerror = (error) => reject(error)
      })
    },
    syncWorkingHoursForOpen(openHour, index) {
      if (index === 0) {
        const monday = this.venue.workingHourList.find(
          (day) => day.workingDay === 'Monday',
        )
        this.venue.workingHourList.forEach((day) => {
          if (
            index === 0 &&
            day.workingDay !== 'Monday' &&
            day.close === false
          ) {
            day.openHour = monday.openHour
          }
        })
      } else {
        this.venue.workingHourList[index].openHour = openHour
      }
    },
    syncWorkingHoursForClose(closeHour, index) {
      if (index === 0) {
        const monday = this.venue.workingHourList.find(
          (day) => day.workingDay === 'Monday',
        )
        this.venue.workingHourList.forEach((day) => {
          if (day.workingDay !== 'Monday' && day.close === false) {
            day.closeHour = monday.closeHour
          }
        })
      } else {
        this.venue.workingHourList[index].closeHour = closeHour
      }
    },
    workingHourControl(openHour, closeHour) {
      if (
        !openHour || !closeHour ||
        openHour.HH === 'HH' ||
        openHour.HH === '' ||
        openHour.mm === 'mm' ||
        openHour.mm === '' ||
        closeHour.HH === 'HH' ||
        closeHour.HH === '' ||
        closeHour.mm === 'mm' ||
        closeHour.mm === ''
      ) {
        this.errorList = []
        this.errorList.push('Çalışma saatleri boş bırakılamaz.')
        this.dialog = true
        return true
      }
    },
    coffeeOptionForPlanTypes(coffeeOption) {
      return (
        (this.selectedPlanType === this.planTypes.BasicPlan &&
          (coffeeOption.coffeeType === this.coffeeOptionsForBasicPlan[0] ||
            coffeeOption.coffeeType === this.coffeeOptionsForBasicPlan[1])) ||
        this.selectedPlanType === this.planTypes.BasicPlusPlan
      )
    },
    onCompanyChange() {
      const selectedCompany = this.allCompanyList.find(
        (company) => company.id === this.venue.companyId,
      )
      if (selectedCompany) {
        this.coffeeExtras = selectedCompany.coffeeExtras == 'True'
        // Check if the selected company is Kahve Dunyası and show the store type select
        this.showVenueStoreType = selectedCompany.companyName === 'Kahve Dünyası'
      }
    },
  },
}
</script>
<style scoped>
/* #coffee1 {
  margin-top: 9px;
}
#coffee2 {
  margin-top: 13px;
} */
.label {
  font-size: 0.8125rem;
  margin-bottom: 0.375rem;
  color: rgba(0, 0, 0, 0.6);
}

.hour-icon {
  display: inline-block;
  vertical-align: middle;
  margin-bottom: -2px;
}

.input-container {
  display: flex;
  align-items: center;
}

.input-container input {
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 0;
}
</style>
